export var RootKeyManagerEvent;
(function (RootKeyManagerEvent) {
    RootKeyManagerEvent["RootKeyManagerKeyStatusChanged"] = "RootKeyManagerKeyStatusChanged";
})(RootKeyManagerEvent || (RootKeyManagerEvent = {}));
